define('editor/edit/map/controls/attribution',['leaflet-attribution'], function () {
    var control = function (options) {
        var self = this;

        self.options = options;

        self.addToMap = function () {
            var viewportDimensions = { width: self.options.editorMap.width, height: self.options.editorMap.height };
            self.control = L.attribution({
                text: self.options.editorMap.attribution,
                viewport: viewportDimensions,
                companyName: self.options.editorMap.companyName
            });

            self.control.addTo(self.options.mapControl);
        };

        self.remove = function () {
            self.control.remove();
        };

        self.updateDimensions = function (dimensions) {
            self.control.update(dimensions);
        };

        self.getHeight = function () {
            return self.control.getHeight();
        };
    };

    return control;
});

